import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import { NoDataFound } from '../../NoDataFound'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'
import axios from 'axios'
import { backendUrl } from '../../../shared/API'
import CustomDialog from '../../CustomDialog'

export default function AttendanceSumaryReport() {
  const { getAttendanceReportSummary, attendance, loading, employees } = useAttendance()
  const [page, setPage] = useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setPage(1)
    getAttendanceReportSummary({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(attendance && attendance.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const initialPara = { absent: null, present: null, total: null, percent: null }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'Area', key: 'area' },
    { label: 'Present', key: 'present' },
    { label: 'Absent', key: 'absent' },
    { label: 'Total', key: 'total' },
    { label: 'Present Percentage', key: 'percentage' },
  ]

  let tempAttendance = []
  attendance &&
    attendance.forEach((item) =>
      tempAttendance.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        area: item.area && item.area.name,
        present: item.present,
        absent: item.absent,
        total: item.total,
        percentage: item.percent + '%',
      })
    )

  const headingOnClick = {
    present: () => {
      setFilterParams({ ...filterParams, ...initialPara, present: filterParams.present === 1 ? -1 : 1 })
    },
    absent: () => {
      setFilterParams({ ...filterParams, ...initialPara, absent: filterParams.absent === 1 ? -1 : 1 })
    },
    total: () => {
      setFilterParams({ ...filterParams, ...initialPara, total: filterParams.total === 1 ? -1 : 1 })
    },
    'present percentage': () => {
      setFilterParams({ ...filterParams, ...initialPara, percent: filterParams.percent === 1 ? -1 : 1 })
    },
    // Agent: () => {
    //   setModalOpen('addedBy')
    //   setOpenFilterModal(true)
    // },
  }

  const onClose = () => {
    setOpen(false)
  }

  console.log({ attendance })

  return (
    <Layout
      heading="Attendance Summary Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempAttendance ? tempAttendance : []}
      tempHeaderData={[]}
      filename="attendance_summary_report"
    >
      <CustomDialog open={open} handleClose={onClose}>
        {open && open != false
          ? open?.map((employee) => {
              return <p>{employee?.employeeName ? employee.employeeName : 'No Data'}</p>
            })
          : ''}
      </CustomDialog>
      {/* <CustomFilterModal
        open={openFilterModal}
        setOpen={setOpenFilterModal}
        data={
          modalOpen === 'leadType'
            ? leadType
            : modalOpen === 'leadStatus'
              ? leadStatus
              : modalOpen === 'addedBy'
                ? employees
                : false
        }
        fieldValue="_id"
        fieldName={modalOpen === 'addedBy' ? 'firstName' : 'name'}
        handleFilter={(filterData) => setFilterParams({ ...filterParams, [modalOpen]: filterData })}
        filterParams={filterParams[modalOpen]}
      /> */}
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            present: <SortIcon onClick={headingOnClick['present']} value={filterParams.present} />,
            absent: <SortIcon onClick={headingOnClick['absent']} value={filterParams.absent} />,
            total: <SortIcon onClick={headingOnClick['total']} value={filterParams.total} />,
            'present percentage': <SortIcon onClick={headingOnClick['present percentage']} value={filterParams.percent} />,
          }}
          heading={['region', 'zone', 'state', 'district', 'city', 'area', 'employees', 'present', 'absent', 'total', 'present percentage']}
        />
        <TableBody className={styles.tr}>
          {!loading &&
            attendance.length > 0 &&
            attendance.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.area ? item.area.name : '-----'} </TableCell>
                  <TableCell>
                    {' '}
                    {item &&
                      item?.allemployees?.map((employee, index) => {
                        if (item?.allemployees?.length == index + 1) {
                          return <span>{employee && employee?.employeeName}</span>
                        } else {
                          return <span>{employee && employee?.employeeName} , </span>
                        }
                      })}{' '}
                  </TableCell>
                  <TableCell> {item.present} </TableCell>
                  <TableCell
                  // style={{ cursor: 'pointer' }}
                  // onClick={() => {
                  //   setOpen(attendance[index]?.allemployees)
                  // }}
                  >
                    {' '}
                    {item.absent}{' '}
                  </TableCell>

                  <TableCell> {item.total} </TableCell>
                  <TableCell> {item.percent + '%'} </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && attendance.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}

      {!loading && attendance.length === 0 && <NoDataFound />}
    </Layout>
  )
}
